export const LEGAL_FORM = [
  { id: 'NOTE', displayValue: 'Note' },
  { id: 'CERTIFICATE', displayValue: 'Certificate' },
  { id: 'WARRANT', displayValue: 'Warrant' },
  { id: 'DEPOSIT', displayValue: 'Deposit' },
  { id: 'EIS', displayValue: 'EIS' },
  { id: 'OTC', displayValue: 'OTC' },
  { id: 'COVERED_BOND', displayValue: 'Covered Bond' },
];

export const FORM_OF_SECURITIES = [
  { id: 'BEARER_PERMANENT', displayValue: 'Bearer Permanent' },
  { id: 'BEARER_TEMPORARY', displayValue: 'Bearer Temporary' },
  { id: 'REGISTERED', displayValue: 'Registered' },
]